import { render, staticRenderFns } from "./SituacaoChaveSelect.vue?vue&type=template&id=768458bc"
import script from "./SituacaoChaveSelect.vue?vue&type=script&lang=js"
export * from "./SituacaoChaveSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports